/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OTPAuthenticate
 */
export interface OTPAuthenticate {
    /**
     * 
     * @type {string}
     * @memberof OTPAuthenticate
     */
    phone_id: string;
    /**
     * 
     * @type {string}
     * @memberof OTPAuthenticate
     */
    code: string;
}

/**
 * Check if a given object implements the OTPAuthenticate interface.
 */
export function instanceOfOTPAuthenticate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone_id" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function OTPAuthenticateFromJSON(json: any): OTPAuthenticate {
    return OTPAuthenticateFromJSONTyped(json, false);
}

export function OTPAuthenticateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAuthenticate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone_id': json['phone_id'],
        'code': json['code'],
    };
}

export function OTPAuthenticateToJSON(value?: OTPAuthenticate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone_id': value.phone_id,
        'code': value.code,
    };
}

